import React, { useEffect, useRef } from 'react';
import { RotatingLines } from 'react-loader-spinner';

const LoadingScreen = () => {
  const overlayRef = useRef(null);

  useEffect(() => {
    // Prevent scrolling
    document.body.style.overflow = 'hidden';

    // Set focus to the overlay when it's mounted
    overlayRef.current.focus();

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div
      ref={overlayRef}
      role="presentation"
      tabIndex={-1} // Make it focusable
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, // Ensure it's above everything else
      }}
      // Prevent any interaction with elements behind the overlay
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <RotatingLines strokeColor="#101316" strokeWidth="3" animationDuration="1.75" width="96" visible />
    </div>
  );
};

export default LoadingScreen;
